export const TYPE_ORDER_VIEW = 'order.view';

export const actionOrderView = ({ value }) => ({
  type: TYPE_ORDER_VIEW,
  payload: { value }
});

